import { AppRoutes } from "../models";
import { Job, SearchFilterQuery } from "../types";
import { DateUtils } from "./dateUtils";

export const formatJobFilter = (filter: SearchFilterQuery): string => {
  if (!filter) return "N/A";
  const parts: string[] = [];
  if (filter.keyword) parts.push(`Keyword: ${filter.keyword}`);

  const locationParts = [
    ...filter.countries,
    ...filter.regions,
    ...filter.cities,
  ];
  if (locationParts.length > 0) {
    parts.push(`Location: ${locationParts.join(", ")}`);
  }

  if (filter.categories?.length > 0) {
    parts.push(`Categories: ${filter.categories.join(", ")}`);
  }

  if (filter.employmentTypes?.length > 0) {
    parts.push(`Types: ${filter.employmentTypes.join(", ")}`);
  }

  if (filter.salaryMinimum) {
    parts.push(`Min Salary: ${filter.salaryMinimum}`);
  }
  if (filter.salaryMaximum) {
    parts.push(`Max Salary: ${filter.salaryMaximum}`);
  }

  return parts.length > 0 ? parts.join(" | ") : "No filters";
};

export function getClipboardCopyText(job: Job | null): string {
  // Clean the job title to remove location info if it already contains it
  let cleanTitle = job?.title || "";
  const city = job?.city || "";

  // Remove "in [city]" from the title if it exists to avoid duplication
  if (city) {
    const escapedCity = escapeRegExp(city);
    const locationPattern = new RegExp(`\\s+in\\s+${escapedCity}.*$`, "i");
    cleanTitle = cleanTitle.replace(locationPattern, "").trim();
  }

  // Build location string with proper spacing
  const locationParts = [job?.city, job?.region, job?.country_code].filter(
    Boolean,
  ); // Remove any undefined/null values

  const locationString =
    locationParts.length > 0 ? locationParts.join(", ") : "";

  // Format hashtags (remove spaces and special characters)
  const categoryTag = formatHashtag(job?.category);
  const employmentTag = formatHashtag(job?.employment_type);

  return `#hiring ${cleanTitle} in ${locationString} during ${DateUtils.getCurrentYear()}

To Apply visit: ${window.location.protocol}//${window.location.host}/${
    AppRoutes.JOB
  }/${job?.jobsrmine_url}

#jobSeekers ${categoryTag} ${employmentTag}`.trim();
}

// Escape special regex characters in the city string
export function escapeRegExp(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function formatHashtag(value: string | undefined): string {
  return value ? `#${value.replace(/\s+/g, "")}` : "";
}

// Keep the public utility import stable; schema mapping has its own responsibility.
export { getJobPostingJsonLd } from "./job-posting-schema";
